<template>
  <div>
    <div style="position: fixed; right: 20px; bottom: 150px">
      <div
        @click="openWebPage('https://www.baidu.com')"
        style="margin-bottom: 5px"
      >
        <img
          src="https://www.chuf.com/assets/img/viber.webp"
          alt="viber"
          style="width: 45px"
          class="mb-2 me-1"
        />
      </div>
      <div @click="openWebPage('https://www.baidu.com')">
        <img
          src="https://www.chuf.com/assets/img/whatsapp.webp"
          alt="whatsapp"
          style="width: 45px"
          class="mb-2 me-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    openWebPage(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped></style>
